import { Static, Object, String, Union, Array, Optional, Literal, Record } from '@sinclair/typebox';

import { UnionEnum } from '../../../utils/unionEnum';
import { BonusProgram } from '../../sas-domain';

import { TravelPassApiError, TravelPassError } from './error';
import { ProductCode } from './travel-pass';

export const TravelPassPassengerFieldError = UnionEnum([
  'invalid-field',
  'first-name-required',
  'first-name-bad-format',
  'last-name-required',
  'last-name-bad-format',
  'middle-name-bad-format',
  'email-required',
  'email-bad-format',
  'phone-required',
  'phone-bad-format',
  'gender-required',
  'gender-bad-format',
  'pax-type-bad-format',
  'date-of-birth-bad-format',
  'infant-adult-association-required',
  'primary-pax-required',
  'date-of-birth-required',
  'date-of-birth-passenger-type-missmatch',
  'eb-invalid',
  'ffp-invalid',
  'ffp-account-invalid',
  'ffp-number-invalid',
  'ffp-name-match-invalid',
  'ffp-duplicate',
]);
export type TravelPassPassengerFieldError = Static<typeof TravelPassPassengerFieldError>;

export const TravelPassRequestBound = Object({
  flight: String(),
  cabin: String(),
});
export type TravelPassRequestBound = Static<typeof TravelPassRequestBound>;

export const TravelPassPassenger = Object({
  id: String(),
  firstName: String(),
  lastName: String(),
  phone: String(),
  gender: String(),
  email: String(),
  ebNumber: Optional(String()),
  middleName: Optional(String()),
  bonusProgram: Optional(BonusProgram),
  type: Optional(String()),
  dateOfBirth: Optional(String()),
});
export type TravelPassPassenger = Static<typeof TravelPassPassenger>;

export const InvoiceDetails = Object({
  orderNumber: String(),
  projectNumber: String(),
  employmentNumber: String(),
  department: String(),
  costCenter: String(),
  customerNumber: String(),
  travelOrderIdentification: String(),
  freeText: String(),
});

export type InvoiceDetails = Static<typeof InvoiceDetails>;

export const TravelPassConfirmRequest = Object({
  offerId: String(),
  productCode: ProductCode,
  outbound: TravelPassRequestBound,
  inbound: Optional(TravelPassRequestBound),
  passengers: Array(TravelPassPassenger),
  invoiceDetails: Optional(InvoiceDetails),
});
export type TravelPassConfirmRequest = Static<typeof TravelPassConfirmRequest>;

export const TravelPassConfirmFieldError = Object({
  bookingErrorType: Literal('passenger-field-errors'),
  payload: Optional(
    Object({
      fieldErrors: Record(String(), Array(TravelPassPassengerFieldError)),
    })
  ),
});
export type TravelPassConfirmFieldError = Static<typeof TravelPassConfirmFieldError>;

export const TravelPassConfirmError = Union([TravelPassApiError(TravelPassError), TravelPassConfirmFieldError]);
export type TravelPassConfirmError = Static<typeof TravelPassConfirmError>;

export const TravelPassConfirmResponse = Object({
  pnr: String(),
  productCode: ProductCode,
});
export type TravelPassConfirmResponse = Static<typeof TravelPassConfirmResponse>;
